import {AbstractBCMProvider} from './abstract';
import {TranslationTableField as TranslationTableFieldModel} from '../model';
import {MANAGEMENT, PROVIDER} from '../../../resources/bcmApi';

export class TranslationTableField extends AbstractBCMProvider {
  management = MANAGEMENT.TRANSLATION;
  model = new TranslationTableFieldModel();
  name = PROVIDER.TRANSLATION_TABLE_FIELDS;
}
